import Footer from "../components/layouts/Footer";
import Header from "../components/layouts/Header";
import HomePage from "../components/home";

const Home = (props) => {
  return (
    <>
      <Header />
      <HomePage />
      <Footer />
    </>
  );
};

export default Home;
